export default __webpack_public_path__ + "static/media/icon-source.90231c68.svg";